import React from 'react';

import { useAppSelector } from '../../components/hooks';
import { getVisibleRoofContainerGuids } from '../../store/selectors/layoutDataSelectors';
import { getRoofGeometriesInLayout } from '../../store/selectors/layoutDocumentSelectors';
import { getActiveRoofMode } from '../../store/selectors/layoutVisualOptionsSelectors';
import { useAutoInvalidateOnChange } from '../hooks/invalidation-hooks';
import { OverhangSolidVisual } from './OverhangSolidVisual';
import { RoofSolidVisual } from './RoofSolidVisual';
import { Segments } from './Segments';

export function RoofContainersController() {
  const roofMode = useAppSelector(getActiveRoofMode);

  const visibleRoofContainers = useAppSelector(getVisibleRoofContainerGuids);

  const visibleRoofGeometries = useAppSelector(getRoofGeometriesInLayout).filter((geometry) =>
    visibleRoofContainers.has(geometry.container.guid),
  );

  useAutoInvalidateOnChange(roofMode, visibleRoofContainers);

  return (
    <>
      <Segments initialSize={100} sizeIncrement={100} lineWidth={1.0}>
        {visibleRoofGeometries.flatMap(({ container, overhangBufferGeometries }) =>
          overhangBufferGeometries.map((overhang, i) => (
            <OverhangSolidVisual key={`${container.guid}-${i}`} geometry={overhang} wireframe={roofMode !== 'solid'} />
          )),
        )}
      </Segments>

      {visibleRoofGeometries
        .filter(({ roofSolidBufferGeometry }) => roofSolidBufferGeometry != null)
        .map(({ container, roofSolidBufferGeometry }) => (
          <RoofSolidVisual
            key={container.guid}
            roofContainer={container}
            roofSolidBufferGeometry={roofSolidBufferGeometry!}
            wireframe={roofMode !== 'solid'}
          />
        ))}
    </>
  );
}
